import { render, staticRenderFns } from "./PaperMedia.vue?vue&type=template&id=fa76c606&scoped=true"
import script from "./PaperMedia.vue?vue&type=script&lang=js"
export * from "./PaperMedia.vue?vue&type=script&lang=js"
import style0 from "./PaperMedia.vue?vue&type=style&index=0&id=fa76c606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa76c606",
  null
  
)

export default component.exports